import Layout from "../components/utils/layout";
import React from "react";
import Formatters from "../components/utils/formatters";

const CardStatements = () => {
    const screenId="CardStatements"
    const formatters = Formatters()
    const charts = {
                card_statement: {
                    source: "redshift",
                    specialFormatters: {
                        started: formatters.isoDateTime,
                        updated: formatters.isoDateTime,
                        description: formatters.long_description
                    }
                }

    }
    return <Layout prefsPrefix={screenId} items={charts}/>
}

export default CardStatements
